export default {
    type: 'numeric',
    format: {
        decimals: 0,
        min: 0,
    },
    default: {
        value: 0,
        to: 0,
        tolerance: 0,
        logic: 'min'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range', 'tolerance']
    },
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Language Independence Votes',
        category: 'BGG',
        description: 'Number of community votes received for language independance.',
        summarise: {
            prefix: 'Language independance received',
            prefixLinked: 'Received'
        },
        unit: 'vote'
    },
    rules: {
        linked: [],
        legacy: ['threshold.language']
    }
}